import React from 'react';
import { fromPairs, map, get, isEqual } from 'lodash';
import classnames from 'classnames';

// local Dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { Form } from 'modules/form';
import { button as Button } from 'modules/button';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { changeNextRefillDate as ChangeNextRefillDate } from 'ui/views/widgets/changeNextRefillDate';
 *
 * // render
 * <ChangeNextRefillDate propName='propValue'/>
 */
export const changeNextRefillDate = ( props ) => {
    return (
        <div className='ui-change-next-refill-date'>
			<div className='ui-change-next-refill-date__header'>

				{ /* modal title */ }
				<div className='ui-change-next-refill-date__header__title'>
					{ getLabel( props.title ) }
				</div>

				{ /* close button */ }
				<div
					className='ui-error-overlay__head__close'
					onClick={ () => props.closeOverlay() }
				>
					<Icon name='close' width='14' height='14' fill='#ffffff' />
				</div>
			</div>
			<div className='ui-change-next-refill-date__body'>

                {/* form description */}
                <div className='ui-change-next-refill-date__body__description'>
                    { getLabel( props.description ) }
                </div>
               
				<Form
                    fields={ fromPairs( map( props.fields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                    values={ props.values } // default values
                    isValid={ false }
                    mode='form'
                    onSubmit={ ( { values, isValid } ) => {
                        if( isValid ) {
                            props.onFormSubmit( {
                                actions: props.actions,
                                payload: props.payload,
                                callback: props.callback,
                                formData: values
                            } );
                        }
                    } }
                >
                    { ( { fields, values, errors, onChange, onSumbit } = {} ) => {

                        return (
                            <form
                                onSubmit={ onSumbit }
                                className='ui-change-next-refill-date__body__form'
                            >
                                { /* fields */ }
                                { map( fields, ( field ) => {

                                    const fieldClassName = classnames( 'ui-change-next-refill-date__body__form__field', `ui-change-next-refill-date__body__form__${field.name}` );
   
                                    return (
                                        <field.view
                                            className={ fieldClassName }
                                            key={ field.name }
                                            name={ field.name }
                                            required={ field.required }
                                            placeholder={ field.placeholder }
                                            label={ field.title }
                                            onChange={ onChange }
                                            value={ values[ field.name ] }
                                            error={ errors[ field.name ] }
                                            options={ get( values.options, field.options ) }
                                            allowFilter={ 'state' === field.name }
                                            config={ field.config }
                                            subFields={ props.subFields }
                                            optionsList={ props.options }
                                        />
                                    );
                                } ) }
                                
                                {/* button actions */}
                                <div className='ui-change-next-refill-date__body__form__actions'>
                                    { map( props.actions, action => {
                                        return (
                                            <Button
                                                key={ action.name }
                                                id= { action.name }
                                                type= { 'cancel' !== action.name ? 'submit' : 'button' }
                                                { ...action }
                                                outline={ 'cancel' === action.name ? true: false }
                                                size='large'
                                                className='ui-change-next-refill-date__body__form__actions__action'
                                                onClick = { isEqual( 'cancel', action.name ) ?  () => {

                                                    // popover.close();
                                                    props.onCancelClick();
                                                } : null }
                                            />
                                        );
                                    } ) }
                                </div>
                            </form>
                        );
                    } }
                </Form>
            </div>
		</div>
    );
};

// set display name
changeNextRefillDate.displayName = 'changeNextRefillDate';

// set default props
changeNextRefillDate.defaultProps = {};

// prop types
changeNextRefillDate.propTypes = {};
